module.exports = __webpack_public_path__ + "img/101.10.b099911c.png";